import Module from "../module";
import * as en from "./translations/en.json";
import * as nl from "./translations/nl.json";
import baseRoute from "./routes/index";

export default new Module(baseRoute, { en, nl }, []);
